import { IsNotEmpty, IsOptional, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import { AddressDto } from "../common";

export class DogCoownerInfoDto {
  @IsNotEmpty()
  coowner_type: string; //owner, handler, junior, ...

  @IsOptional()
  coowner_number?: string;

  @IsOptional()
  email?: string;

  @IsOptional()
  first_name?: string;

  @IsOptional()
  last_name?: string;

  @IsNotEmpty()
  display_name: string;

  @IsOptional()
  phone?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AddressDto)
  address?: AddressDto;
}
